import React from 'react';
import {connect} from 'react-redux';
import {selectors} from '../../Redux/index';

import PageContent from '../../Components/Helper/PageContent';

const Page = (props) => {
    switch (props.language) {
        case 'en':
            return (
                <PageContent>
                    <h1>Privacy Statement</h1>
 
                    <a href={process.env.PUBLIC_URL + '/pdf/privacy_statement/privacy_statement.pdf'} target="_blank" rel="noopener noreferrer">Download
                        PDF-File</a>

                    <br />
                    <br />

                    <p>Deutsche Bank recognizes the importance of protecting the privacy of the personal information,
                        which has been given to us. We believe that the confidentiality and protection of information
                        entrusted to us by our clients and website visitors is one of our fundamental responsibilities.
                        We have been safeguarding our clients' privacy for decades by maintaining strict standards of
                        security and procedures which are especially designed to prevent misuse of this information. We
                        would like to explain some of our procedures which are intended to protect your privacy.</p>

                    <h2>Why does Deutsche Bank collect personal data?</h2>
                    <p>We collect, retain and use information about you for the purpose of better serving your financial
                        needs and administering our business. We limit the collection and use of client information to
                        the minimum required for delivering outstanding service to our clients.</p>

                    <h2>How does Deutsche Bank collect data and how long will it be stored?</h2>
                    <p>Whenever we collect personal data, our website visitors will be informed about the extent to
                        which we collect. Furthermore, we will not collect personal data without the explicit consent
                        from our website visitors.</p>

                    <p>All personal data will normally be stored until it has fulfilled the purpose it was collected
                        for. However, if a website visitor wants his personal data removed from our databases, we will
                        delete his personal data upon written request (in accordance with the applicable laws). At your
                        request, we will also inform you about personal data stored concerning yourself.</p>

                    <p>Deutsche Bank is committed to the continuous improvement of its websites. We gather and analyze
                        data regarding the use of our websites anonymously, including domain names, number of hits,
                        pages visited, length of user session, etc., to evaluate the usefulness of our sites, but these
                        are for statistical purposes only and are not shared with any other organization outside the
                        Deutsche Bank Group.</p>

                    <h2>How is data saved, protected and used?</h2>
                    <p>The personal information gathered will be referred to the relevant Deutsche Bank unit. Banking
                        secrecy and confidentiality of that data will be kept. Controller of the data will be the
                        relevant legal entity. Data will not be shared with any organization outside the Deutsche Bank
                        Group, unless this should be required to for example perform information services, which may be
                        done by a subcontractor (e.g. sending out publications to which the customer has subscribed
                        before). The data will only be used according to the purposes described on the respective
                        website where the data had been collected.</p>

                    <p>Pages where we collect personal data from our website visitors are usually encrypted with your
                        browser's internal encryption module. These pages, as well as the e-trade system of Deutsche
                        Bank, are certified by renowned international accredited certification institutions. Deutsche
                        Bank has implemented additional, comprehensive state-of-the-art security procedures for our
                        e-trade system. A firewall prevents external access to account information from Deutsche Bank's
                        system. Moreover, multiple layers of encryption and identification prevent unauthorized
                        inquiries or interception by the transmission of client information. In addition to the
                        encryption procedures provided by standard browsers, Deutsche Bank uses even stronger encryption
                        systems within its banking systems, to further exclude decoding by unauthorized persons. An
                        electronic finger print, which guarantees that no manipulation takes place during the
                        transmission, is produced simultaneously.</p>

                    <p>If at any time you are not satisfied with our procedure to protect your privacy, or if you have
                        questions regarding the collection and/or use of your personal data or regarding our privacy
                        policy, please contact us. We will use all commercially reasonable efforts to promptly address
                        your concern.</p>

                    <p>Feel free to contact us via e-mail to <a href="mailto:deutsche.bank@db.com" style={{textDecoration: "underline" }}>deutsche.bank@db.com</a> in order to send your inquiry to us.</p>

                    <p>Published by Deutsche Bank AG.<br/> © Deutsche Bank AG, Frankfurt am Main.<br/> All rights
                        reserved.</p>
                </PageContent>
            );

        default:
            return (
                <PageContent>
                    <h1>Hinweise zum Datenschutz</h1>

                    <a href={process.env.PUBLIC_URL + '/pdf/privacy_statement/Hinweise_zum_Datenschutz.pdf'} target="_blank" rel="noopener noreferrer">Download
                        PDF-File</a>

                    <br />
                    <br />

                    <p>Die Deutsche Bank AG ist sich der Bedeutung der personenbezogenen Daten, die anvertraut werden,
                        bewusst. Es ist eine der fundamentalen Aufgaben als Bank, die Vertraulichkeit der Daten
                        sicherzustellen, die von Kunden und Besuchern dieser Website anvertraut werden. Seit Jahrzehnten
                        werden die personenbezogenen Daten der Kunden durch die Anwendung hoher Sicherheitsstandards und
                        durch Arbeitsabläufe, die besonders dazu geschaffen wurden, um den Missbrauch dieser Daten zu
                        verhindern, geschützt. Im Folgenden werden einige der Vorkehrungen erklärt, die dem Schutz Ihrer
                        Privatsphäre dienen.</p>

                    <h2>Warum erhebt die Deutsche Bank personenbezogene Daten?</h2>
                    <p>Wir erheben, verarbeiten und nutzen personenbezogene Daten auf dieser Website zu dem Zweck, Ihnen
                        noch bessere Produkte und Dienstleistungen anbieten zu können und um unsere Geschäftsabläufe
                        noch stärker auf unsere Kunden auszurichten. Wir beschränken die Datenerhebung, deren
                        Verarbeitung und Nutzung dabei auf ein Mindestmaß, um unseren Kunden weiterhin hervorragende
                        Produkte und Dienstleistungen anbieten zu können und unsere Website- Besucher mit den
                        Produktinformationen versorgen zu können, die für sie besonders interessant sind.</p>

                    <h2>Wie erhebt die Deutsche Bank Daten, und wie lange werden diese gespeichert?</h2>
                    <p>Gemäß den Vorgaben des deutschen Datenschutzrechtes werden unsere Website-Besucher über jede
                        Datenerhebung informiert, soweit personenbezogene Daten betroffen sind. Darüber hinaus erheben,
                        nutzen und verarbeiten wir keine personenbezogenen Daten ohne Ihre ausdrückliche Einwilligung,
                        die auch elektronisch erklärt werden kann. Eine einmal erklärte Einwilligung kann jederzeit mit
                        Wirkung für die Zukunft widerrufen werden.</p>

                    <p>Personenbezogene Daten, die uns über unsere Website mitgeteilt worden sind, werden nur solange
                        gespeichert, bis der Zweck erfüllt ist, zu dem sie uns anvertraut wurden. Sollten Sie mit der
                        Speicherung Ihrer personenbezogenen Daten nicht mehr einverstanden oder diese unrichtig geworden
                        sein, werden wir auf eine entsprechende Weisung hin die Löschung oder Sperrung Ihrer Daten
                        veranlassen oder die notwendigen Korrekturen vornehmen (soweit dies nach dem geltendem Recht
                        möglich ist). Auf Wunsch erhalten Sie unentgeltlich Auskunft über alle personenbezogenen Daten,
                        die wir über Sie gespeichert haben.</p>

                    <p>Daneben bemüht sich die Deutsche Bank um die ständige Verbesserung der Website. Wir erheben aus
                        diesem Grund in anonymisierter Form Daten über die Nutzung unserer Website, wie zum Beispiel die
                        Herkunftsdomain, die Anzahl der Seitenabrufe, die Länge des Aufenthaltes etc. Diese Daten dienen
                        rein statistischen und Marktforschungszwecken und werden nicht an Dritte außerhalb der Deutsche
                        Bank Gruppe weitergegeben.</p>

                    <h2>Wie werden Daten gespeichert, geschützt und ausgewertet?</h2>
                    <p>Die auf dieser Website gesammelten Informationen werden an die zuständige Einheit innerhalb der
                        Deutsche Bank Gruppe weitergeleitet. Das Bankgeheimnis sowie die Vertraulichkeit der Daten
                        bleiben hierbei gewahrt. Speichernde Stelle ist die jeweilige juristische Person. Die Daten
                        werden nicht an Dritte außerhalb der Deutsche Bank Gruppe weitergegeben, sofern dies nicht
                        beispielsweise zur Erfüllung von Informationsdienstleistungen erforderlich ist (z.B. Versand von
                        abonnierten Publikationen per e-Mail durch externe Dienstleister). Die personenbezogenen Daten
                        werden nur entsprechend dem Zweck genutzt, der sich aus der betreffenden Seite unserer Website
                        ergibt, auf der die Daten erhoben wurden.</p>

                    <p>Seiten, auf denen wir personenbezogene Daten erheben, sind üblicherweise mit dem in Ihrem Browser
                        eingebautem Verschlüsselungsmodul kodiert. Diese Seiten sind, wie auch das e-trade System der
                        Deutschen Bank, durch renommierte und für die internationale Verschlüsselungszertifizierung
                        zugelassene Einrichtungen zertifiziert. Daneben hat die Deutsche Bank zusätzliche, umfangreiche
                        Sicherheitsvorkehrungen gemäß dem letzten Stand der Technik für den Internet-Zugang zu
                        Handelssystemen getroffen. Ein Firewall-System verhindert den Zugang von außen. Mehrere Ebenen
                        von Verschlüsselung und Identifizierung schließen unautorisierte Abfragen oder das Abfangen von
                        Kundendaten bei der Übertragung aus. Neben den internen Verschlüsselungsverfahren der
                        Internet-Browser benutzt die Deutsche Bank noch stärkere Verschlüsselungsverfahren innerhalb
                        ihrer eigenen Bank-Systeme, um eine Dekodierung durch dazu nicht ermächtigte Personen
                        auszuschließen. Ein elektronischer Fingerabdruck wird während der Übertragung von Daten
                        erstellt, um Manipulationen zu verhindern.</p>

                    <p>Sollten Sie mit den hier dargestellten Maßnahmen zum Datenschutz nicht zufrieden sein, oder haben
                        Sie noch Fragen betreffend der Erhebung, Verarbeitung und/oder der Nutzung Ihrer
                        personenbezogenen Daten, so würden wir uns freuen, von Ihnen zu hören. Wir werden uns bemühen,
                        Ihre Fragen so rasch wie möglich zu beantworten und Ihre Anregungen umzusetzen.</p>

                    <p>Bitte treten Sie unter <a href="mailto:deutsche.bank@db.com" style={{textDecoration: "underline" }}>deutsche.bank@db.com</a>  mit uns in
                        Kontakt.</p>

                    <p>Veröffentlicht durch Deutsche Bank AG.<br/> © Deutsche Bank AG, Frankfurt am Main.<br/> Alle
                        Rechte vorbehalten.</p>
                </PageContent>
            )
    }
};

const mapStateToProps = (state) => {
    return {
        language: selectors.UI.Locale.getLocale(state)
    };
};

export default connect(mapStateToProps)(Page);
